import React, { useState } from 'react'
import { ReactComponent as CloseIcon } from '../../assets/img/icons/close-icon.svg'
import { ModalWindowAction } from '../../store/ModalWindowData/types'
import { apiV2, wrapResponse } from '../../repositories/repository'
import useTranslate from '../../hooks/useTranslate'

type PropsFromState = {
  onConfirm: (data: ModalWindowAction<any>) => void;
  data: Record<string, never>;
}

const SAMPLE_PDF_URL = 'https://blue-resonance.objects.dc-sto1.glesys.net/symtomenk_ver3_2_2020_copyright_ragnarastrand.pdf'

export const SymptomSurveyPopup = ({ onConfirm }: PropsFromState) => {
  const t = useTranslate()
  const [showForm, setShowForm] = useState(false)
  const [firstName, setFirstName] = useState('Anonymous')
  const [lastName, setLastName] = useState('Patient')
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const handleClose = () => onConfirm({ action: 'cancel', data: null })

  const handleSamplePdf = () => {
    window.open(SAMPLE_PDF_URL, '_blank')
  }

  const handleSubmit = async () => {
    setIsLoading(true)
    setError(null)
    const newTab = window.open('', '_blank')
    const result = await wrapResponse(
      apiV2.medStaff.fillSymptomSurveyYourself({ firstName, lastName })
    )
    setIsLoading(false)
    if (result.success) {
      if (newTab) newTab.location.href = result.data.symptomSurveyUrl
      handleClose()
    } else {
      if (newTab) newTab.close()
      setError(result.error)
    }
  }

  return (
    <div>
      <div className="note-popup_header flex collapse justify-betweenalign-center">
        <div className="flex-item flex-item--stretch">{t('symptom-survey.modal.title')}</div>
        <div className="flex-item flex-item--shrink">
          <button type="button" onClick={handleClose}><CloseIcon /></button>
        </div>
      </div>

      {!showForm ? (
        <div className="ph-10 pb-20" style={{ display: 'flex', gap: '12px', marginTop: '20px' }}>
          <button
            className="g_btn g_btn--primary"
            type="button"
            onClick={() => setShowForm(true)}
          >
            {t('symptom-survey.modal.fill-yourself')}
          </button>
          <button
            className="g_btn g_btn--outlined"
            type="button"
            onClick={handleSamplePdf}
          >
            {t('symptom-survey.modal.sample-pdf')}
          </button>
        </div>
      ) : (
        <div className="ph-10 pb-20">
          <div className="input-holder" style={{ marginTop: '14px' }}>
            <label>{t('symptom-survey.modal.patient-name')}</label>
            <input
              type="text"
              value={firstName}
              onChange={e => setFirstName(e.target.value)}
            />
          </div>
          <div className="input-holder" style={{ marginTop: '14px' }}>
            <label>{t('symptom-survey.modal.patient-surname')}</label>
            <input
              type="text"
              value={lastName}
              onChange={e => setLastName(e.target.value)}
            />
          </div>
          {error && <div className="login_form-error" style={{ marginTop: '8px' }}>{error}</div>}
          <div className="note-popup_footer">
            <button
              className="g_btn g_btn--primary"
              type="button"
              disabled={isLoading || !firstName || !lastName}
              onClick={handleSubmit}
            >
              {isLoading ? t('symptom-survey.modal.loading') : t('symptom-survey.modal.submit')}
            </button>
            <button
              className="g_btn g_btn--outlined"
              type="button"
              onClick={handleClose}
            >
              {t('cancel')}
            </button>
          </div>
        </div>
      )}
    </div>
  )
}
